import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function CategoryPage() {
  const { slug } = useParams();
  const loc = useLocation();
  const [products, setProducts] = useState([]);
  const [cat, setCat] = useState(null);
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);

  const q = new URLSearchParams(loc.search).get("q") || "";

  useEffect(() => {
    setLoading(true);
    api.get("/categories").then((r) => setCats(r.data || []));
    const params = {};
    if (slug) params.category = slug;
    if (q) params.search = q;
    api
      .get("/products", { params })
      .then((r) => setProducts(r.data || []))
      .finally(() => setLoading(false));
    if (slug) {
      api.get("/categories").then((r) => {
        const c = (r.data || []).find((x) => x.slug === slug);
        setCat(c || null);
      });
    } else {
      setCat(null);
    }
  }, [slug, q]);

  const title = q ? `Busca: "${q}"` : cat?.name || "Produtos";
  const subtitle = q ? `${products.length} resultado(s)` : cat?.description || "";

  return (
    <div className="mx-auto max-w-7xl px-5 lg:px-8 py-14">
      <div className="overline-label">Catálogo</div>
      <h1 className="font-display text-5xl sm:text-6xl tracking-tighter text-white mt-3" data-testid="category-title">{title}</h1>
      {subtitle && <p className="text-zinc-400 mt-3 max-w-2xl">{subtitle}</p>}

      {/* Category chips */}
      <div className="flex flex-wrap gap-2 mt-8">
        {cats.map((c) => (
          <a
            key={c.id}
            href={`/categoria/${c.slug}`}
            className={`text-xs tracking-widest uppercase px-4 py-2 border transition-colors ${
              slug === c.slug
                ? "bg-white text-black border-white"
                : "border-white/15 text-zinc-300 hover:border-white"
            }`}
            data-testid={`chip-${c.slug}`}
          >
            {c.name}
          </a>
        ))}
      </div>

      <div className="mt-10">
        {loading ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="aspect-[4/5] shimmer" />
            ))}
          </div>
        ) : products.length === 0 ? (
          <div className="py-20 text-center text-zinc-500" data-testid="category-empty">
            <p className="font-display text-2xl text-white">Nenhum produto encontrado</p>
            <p className="mt-2 text-sm">Volte em breve ou explore outras categorias.</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
